import { Button, Card, Spinner, Typography } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { useShared } from "../../hooks/useShared";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import ABreadcrumbs from "../../components/breadcrumbs/ABreadcrumbs";
import AInput from "../../components/fields/AInput";
import ASelect from "../../components/fields/ASelect";
import ASpinner from "../../components/partials/ASpinner";
import CustomItemsFields from "./CustomItemsFields";
import { useParams } from "react-router-dom";
import AIcon from "../../components/partials/AIcon";

const inputFields = {
  company: {
    label: "شرکت",
    name: "company",
    type: "select",
    roles: [1],
    icon: "text-outline",
    className: "",
    required: "Please select a company.",
    options: []
  },
  tariff: {
    label: "تعرفه",
    name: "letter_tariff",
    type: "select",
    roles: [1],
    icon: "text-outline",
    className: "",
    required: "Please select a company.",
    options: []
  },

  items: {
    label: "اجناس",
    name: "items",
    type: "items_comp",
    roles: [1],
    icon: "text-outline",
    className: "",
    required: true,
    options: {
      head: ["نام جنس", "متراژ", "نوع"],
      fields: { category: null, quantity: null, item_type: null }
    }
  },

  letter_status: {
    label: "نوع مکتوب",
    name: "letter_status",
    type: "select",
    roles: [1],
    icon: "book-outline",
    className: "",
    required: true,
    options: [
      { value: 1, label: "عاجل" },
      { value: 2, label: "عادی" },
      { value: 3, label: "اطمينانی" },
      { value: 4, label: "ابلاغيه" }
    ]
  },
  /*   zone: {
        label: 'زون', name: 'zone', type: 'select', roles: [1], icon: 'book-outline', className: '', required: true,
        options: []
    }, */
  date: {
    label: "تاریخ",
    name: "date",
    type: "pdate",
    roles: [1],
    icon: "text-outline",
    className: "",
    required: true,
    options: []
  },
  /* acmeg_from: { label: 'From (ACMEG)', name: 'acmeg_from', type: 'text', roles: [1], icon: 'book-outline', className: '', required: true, }, */
  description: {
    label: "ملاحظات",
    name: "description",
    type: "textarea",
    roles: [1],
    icon: "book-outline",
    className: "",
    required: false,
    isStyle: false
  }
};

export default function NewDutyLetter() {
  const {
    http,
    photo,
    auth,
    setModel,
    com,
    navigate,
    setMessage,
    fetchModelCounts,
    funs
  } = useShared();

  useEffect(() => {
    if (!auth.hasRole([1, 2, 4, 27])) {
      return navigate("/db/notAllowed");
    }
  }, []);

  const [breadcrumbs, setBreadcrumbs] = useState([
    { name: "مکتوب جديد", link: null }
  ]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tarifInput, setTarifInput] = useState({ ...inputFields.tariff });
  const [companyInput, setCompanyInput] = useState({ ...inputFields.company });
  //const [zone, setZone] = useState({ ...inputFields.zone })
  const [hasInvoice, setHasInvoice] = useState(false);
  const [items, setItems] = useState([]);
  const { id } = useParams();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue
  } = useForm({});

  //get Letter by Id
  useEffect(() => {
    if (id > 0) {
      setModel(null);
      setLoading(true);
      setValue("acmeg_from", "فنی");
      http.get(`/api/exdletters/${id}`).then(
        res => {
          console.log("get model ", res);
          if (res.data.success && res.data.data) {
            reset(res.data.data);
            getCompanyies();
            invoiceCompanyChange(res.data.data?.company);
          }
          setLoading(false);
        },
        err => {
          console.log("err");
          setLoading(true);
        }
      );
    }
  }, []);

  //get all companies
  const getCompanyies = () => {
    if (companyInput.options?.length === 0) {
      setLoading(true);

      //Normal User
      if (com?.isRole([4])) {
        http.get(`/api/companies?uId=${auth?.getUserID()}`).then(res => {
          console.log("get companies normaal user", res);
          if (res.data.success) {
            if (res?.data?.data?.length > 0) {
              // setCompanyInput(pre=>({...pre, isDisabled:true, options:res.data.data}))
              setValue("company", res?.data?.data[0]);
              // setCompanyInput(pre => ({ ...pre, options: res.data.data }))
              invoiceCompanyChange(res?.data?.data[0]);
              setLoading(false);
            } else {
              setErrorMessage(
                "شما شرکت خود را در ديتابيس ثبت نکرده اید! لطفا اول آن را ثبت کنید."
              );
              setLoading(false);
            }
          }
        });
      } else if (!com?.isRole([4])) {
        http.get(`/api/companies?nameId=true`).then(res => {
          console.log("get companies ", res);
          if (res.data.success) {
            const data = res.data.data;
            if (data?.length > 0)
              setCompanyInput(pre => ({ ...pre, options: data }));
          }
          setLoading(false);
        });
      }
    }
  };
  useEffect(() => {
    if (inputFields.company.options?.length === 0) getCompanyies();
  }, [inputFields.company]);

  //get tariffs
  const getTriffs = cId => {
    setErrorMessage(null);
    setTarifInput(pre => ({ ...pre, options: [] }));
    http
      .post(`/api/tariffsAdvanceSearch`, { company_id: cId, tariff_type: 21 })
      .then(res => {
        console.log(cId, "get tariffs ", res);
        if (res.data.success) {
          const data = res.data.data;
          if (data?.length > 0) {
            setTarifInput(pre => ({ ...pre, options: data }));

            if (id > 0) tarifChange(res.data.data[0]);
          } else {
            setErrorMessage(`لطفا اولا برای اقلام صادراتی خود تعرفه بسازيد !`);
          }
        }
      });
  };

  /* //get Zones
     const Zones = () => {
         console.log("zone")
        setErrorMessage(null)
        setTarifInput(pre => ({ ...pre, options: [] }))
        http.post(`/api/zonesAdvanceSearch`, {nameId:true}).then(res => {
            console.log( 'get zones ', res);
            if (res.data.success) {

                const data = res.data.data
                if (data?.length > 0) {
                    setZone(pre => ({ ...pre, options: data }))
                  //  if (id > 0) setZone(data[0])

                }

            }
        })
    }
 */

  const mReset = () => {
    reset({});
  };

  const submit = async submitData => {
    console.log("submit", submitData);
    setErrorMessage(null);
    funs?.getBla();
    const bla = funs?.bla;
    if (bla && (bla?.err?.status === 1 || bla.actions?.status === 1)) {
      console.log(bla);
      if (bla?.err?.status === 1) {
        setErrorMessage(bla?.err?.msg);
        toast.error(bla?.err?.msg);
      }
    } else {
      try {
        setLoading(true);
        const res = await http.post(`api/${"exdletters"}`, submitData);

        console.log("model  ", res);

        if (res.data?.success) {
          //const invoice = res.data?.data;
          // upload image if exists
          setLoading(false);
          toast.success(res.data.message);
          setMessage(res.data.message);
          navigate(-1);
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
        const err = error?.response?.data;

        if (!err?.success) {
          setErrorMessage(err?.message);
          toast.error(err?.message);
        }
      }
    }
    return false;
  };

  //get invoice by Tariff id
  const getInvoiceByTariffID = triff => {
    http
      .post(`/api/invoicesAdvanceSearch?getInvoiceByTariffID=${triff?.value}`)
      .then(res => {
        console.log("get getInvoiceByTariffID ", res);
        if (res.data.success && res.data.data) {
          setHasInvoice(true);
          setValue("letter_tariff", {
            value: triff?.value,
            label: triff?.label
          });
          let items = [];
          triff?.items?.map((it, i) => {
            items.push({
              category: it?.category,
              quantity: it?.quantity,
              price_per_unit: it?.price_per_unit,
              item_type: it?.item_type,
              sort: it?.sort,
              id: it?.id
            });
          });
          setItems(items);
          setValue("items", items);
        } else {
          setErrorMessage(
            "لطفاً مطمئن شوید که برای اقلام صادراتی خود اينوايس ایجاد کرده اید"
          );
        }
      });
  };

  const invoiceCompanyChange = e => {
    console.log("invoiceCompanyChange", e);
    setValue("company", e);
    getTriffs(e.value);
    // Zones()
  };

  const tarifChange = e => {
    console.log("tarifChange", e);
    setErrorMessage(null);
    getInvoiceByTariffID(e);
    console.log(items);
  };

  return (
    <>
      <ABreadcrumbs links={breadcrumbs} />

      <div className="md:flex  items-start gap-4">
        <Card className="w-full p-2 md:p-4 mt-4 relative">
          <p className="text-sm text-main-color font-bold capitalize">
            معلومات مکتوب جديد
          </p>
          <form
            className=" flex flex-col gap-4 mt-4"
            onSubmit={handleSubmit(submit)}
          >
            {loading && <ASpinner />}

            <div className="grid md:grid-cols-1 gap-4">
              {companyInput?.options?.length > 0 && (
                <ASelect
                  v={{ register, errors, control, data: companyInput }}
                  onChange={invoiceCompanyChange}
                />
              )}
              {/*     {zone?.options?.length > 0 && <ASelect v={{ register, errors, control, data: zone }}/>} */}

              {tarifInput?.options?.length > 0 && (
                <>
                  {" "}
                  <ASelect
                    v={{ register, errors, control, data: tarifInput }}
                    onChange={tarifChange}
                  />
                  {items?.length > 0 && hasInvoice && (
                    <>
                      <CustomItemsFields
                        v={{
                          register,
                          errors,
                          control,
                          data: inputFields.items?.options,
                          items: "items"
                        }}
                      />
                      <ASelect
                        v={{
                          register,
                          errors,
                          control,
                          data: inputFields.letter_status
                        }}
                      />

                      {/*   <AInput v={{ register, errors, data: inputFields.acmeg_from }} /> */}
                      <AInput
                        v={{ register, errors, data: inputFields.description }}
                      />
                    </>
                  )}
                </>
              )}
            </div>

            {errorMessage && (
              <Typography
                style={{ direction: "rtl" }}
                variant="small"
                color="gray"
                className="flex items-center text-red-500 gap-2 font-normal text-base"
              >
                <AIcon
                  name="alert-circle-outline"
                  className="-mt-0.5 h-4 w-4"
                />
                {errorMessage}
              </Typography>
            )}
            <div className="flex gap-4 md:justify-start">
              <Button
                className="btn1 w-full md:w-[10%] amiriB text-white text-base"
                size="sm"
                type="submit"
                disabled={
                  loading || tarifInput?.options?.length === 0 || !hasInvoice
                }
              >
                {" "}
                {loading ? (
                  <Spinner color="teal" className="h-4 w-4" />
                ) : (
                  "ارسال"
                )}{" "}
              </Button>
              <Button
                variant="outlined"
                size="sm"
                color="gray"
                onClick={() => mReset()}
              >
                Reset
              </Button>
            </div>
          </form>
        </Card>
      </div>
      <ToastContainer />
    </>
  );
}
